import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import LocalizationListService from '../services/LocalizationListService';
import LocalizationListFilter from './LocalizationListFilter';

class LocalizationListFilterContainer extends React.Component {
  static propTypes = {
    initialFilters: PropTypes.object,
  };

  componentDidMount() {
    LocalizationListService.init();
    LocalizationListService.form.setValue('onlyEmpty', !!this.props.initialFilters.locale);
  }

  handleSearch() {
    LocalizationListService.pagination.current = 1;
    LocalizationListService.firstLocaleSelect = LocalizationListService.form.getValue('firstLocaleSelect');
    LocalizationListService.secondLocaleSelect = LocalizationListService.form.getValue('secondLocaleSelect');
    LocalizationListService.load();
  }

  render() {
    return (
      <LocalizationListFilter
        values={LocalizationListService.form.getValues()}
        onChange={LocalizationListService.form.setValue}
        fetching={LocalizationListService.fetch.fetching}
        onSearch={this.handleSearch}
      />
    );
  }
}

export default observer(LocalizationListFilterContainer);
